import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import GalleryPage from './pages/GalleryPage';
import ServicePage from './pages/ServicePage';
import TermsPrivacyPage from './pages/TermsPrivacyPage';

// Scrolls to top on route changes. If the URL contains a hash (e.g. /#team),
// scrolls to that section instead. A short delay allows the new page to render
// before the target element is queried.
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Nav />
      <div className="page-wrap">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/gallery/:slug" element={<GalleryPage />} />
          <Route path="/terms-and-privacy" element={<TermsPrivacyPage />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
}
